import $ from "jquery";
import { register } from "@shopify/theme-sections";

const selectors = {
	body: "body",
	headerId: "header",
	$headerId: "#header",
	openSearchButton: '[data-action="open-search"]',
	searchInput: '[type="search"]',
	$searchWrapperClass: ".search-wrapper .container",
	// $searchResultWrapperClass: ".algolia-autocomplete",
	$headerCollectionSearch: ".header-search__collections",
	$headerCollectionSuggestionSearch:
		".header-search__collections .aa-suggestions",
	$headerCollectionScrollArrow: ".header-search__collections .scroll-arrow"
};

const classes = {
	openSearch: "header--open-search",
	scrolled: "scrolled"
};

const observerConfig = { attributes: true, childList: true, subtree: true };
const targetNode = document.querySelector(selectors.body);
const hasScrollBar = (element) => {
	return element.scrollWidth > element.offsetWidth;
};

register("header", {
	onLoad: function () {
		document
			.querySelectorAll(selectors.openSearchButton)
			.forEach((element) => {
				element.addEventListener("click", this.openSearch.bind(this));
			});

		document.querySelectorAll(selectors.searchInput).forEach((element) => {
			element.addEventListener("input", this.searchScrollLock.bind());
		});

		document.body.addEventListener("click", this.onBodyClick.bind(this));
	},
	openSearch(event) {
		event.preventDefault();
		document
			.getElementById(selectors.headerId)
			.classList.add(classes.openSearch);
		document.querySelectorAll(selectors.searchInput).forEach((element) => {
			if ((window.screen.width < 1200) & element.id.includes("mobile")) {
				setTimeout(() => element.focus(), 0);
			} else {
				element.focus();
			}
		});
	},
	searchScrollLock() {
		setTimeout(function () {
			const searchResultWrapper = $(selectors.$searchResultWrapperClass);
			if (searchResultWrapper) {
				for (
					let i = 0;
					i < $(selectors.$searchResultWrapperClass).length;
					i++
				) {
					let searchDisplay = window.getComputedStyle(
						searchResultWrapper[i],
						null
					).display;
					global.bodyScrollLock.enableBodyScroll(selectors.body);

					if (searchDisplay == "block") {
						global.bodyScrollLock.disableBodyScroll(selectors.body);
					}
				}
			}
		}, 150);
	},
	onBodyClick(event) {
		let searchIcon = $(selectors.openSearchButton);
		let searchContainer = $(selectors.$searchWrapperClass);
		let searchResultWrapper = $(selectors.$searchResultWrapperClass);

		if (
			!searchIcon.is(event.target) &&
			!searchIcon.has(event.target).length
		) {
			if (
				!searchContainer.is(event.target) &&
				!searchContainer.has(event.target).length
			) {
				if (
					!searchResultWrapper.is(event.target) &&
					!searchResultWrapper.has(event.target).length
				) {
					if ($(selectors.$headerId).hasClass(classes.openSearch)) {
						$(selectors.$headerId).removeClass(classes.openSearch);
						$(selectors.searchInput).val("");
						global.bodyScrollLock.enableBodyScroll(selectors.body);
					}
				}
			}
		}
	}
});

class StickyHeader extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.body = document.body;
		this.header = document.getElementById("shopify-section-header");
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;

		this.onScrollHandler = this.onScroll.bind(this);
		this.showHeaderOnScrollUp = () => (this.preventReveal = true);

		this.addEventListener("preventHeaderReveal", this.showHeaderOnScrollUp);
		window.addEventListener("scroll", this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener(
			"preventHeaderReveal",
			this.showHeaderOnScrollUp
		);
		window.removeEventListener("scroll", this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
			this.headerBounds = entries[0].intersectionRect;
			observer.disconnect();
		});

		observer.observe(this.header);
	}

	onScroll() {
		const scrollTop =
			window.pageYOffset || document.documentElement.scrollTop;

		if (
			scrollTop > this.currentScrollTop + 70 &&
			scrollTop > this.headerBounds.bottom + 70
		) {
			requestAnimationFrame(this.hide.bind(this));
		} else if (
			scrollTop < this.currentScrollTop &&
			scrollTop > this.headerBounds.bottom
		) {
			if (!this.preventReveal) {
				requestAnimationFrame(this.reveal.bind(this));
			} else {
				window.clearTimeout(this.isScrolling);

				this.isScrolling = setTimeout(() => {
					this.preventReveal = false;
				}, 66);
				requestAnimationFrame(this.hide.bind(this));
			}
		} else if (scrollTop <= this.headerBounds.top) {
			requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		this.body.classList.add("body-header-hidden", "body-header-sticky");
		this.header.classList.add(
			"shopify-section-header-hidden",
			"shopify-section-header-sticky"
		);
	}

	reveal() {
		this.body.classList.add("body-header-sticky");
		this.header.classList.add("shopify-section-header-sticky", "animate");
		this.body.classList.remove("body-header-hidden");
		this.header.classList.remove("shopify-section-header-hidden");
	}

	reset() {
		this.body.classList.remove("body-header-hidden", "body-header-sticky");
		this.header.classList.remove(
			"shopify-section-header-hidden",
			"shopify-section-header-sticky",
			"animate"
		);
	}
}

customElements.define("sticky-header", StickyHeader);

const callback = function (mutationsList) {
	for (const mutation of mutationsList) {
		if (mutation.type === "childList") {
			const collectionScrollWrapper = document.querySelectorAll(
				selectors.$headerCollectionSearch
			);
			const collectionScroll = document.querySelector(
				selectors.$headerCollectionSuggestionSearch
			);
			if (collectionScrollWrapper !== null && collectionScroll !== null) {
				document
					.querySelectorAll(selectors.$headerCollectionScrollArrow)
					.forEach((element) => {
						element.addEventListener("click", function () {
							collectionScroll.scrollLeft += 200;
						});
					});

				setTimeout(function () {
					if (
						hasScrollBar(collectionScroll) &&
						!collectionScrollWrapper[0].classList.contains(
							classes.scrolled
						)
					) {
						collectionScrollWrapper[0].classList.add(
							classes.scrolled
						);
						collectionScrollWrapper[1].classList.add(
							classes.scrolled
						);
					} else if (
						!hasScrollBar(collectionScroll) &&
						collectionScrollWrapper[0].classList.contains(
							classes.scrolled
						)
					) {
						collectionScrollWrapper[0].classList.remove(
							classes.scrolled
						);
						collectionScrollWrapper[1].classList.remove(
							classes.scrolled
						);
					}
				}, 500);

				collectionScroll.style.cursor = "grab";

				let pos = { top: 0, left: 0, x: 0, y: 0 };
				const mouseDownHandler = function (e) {
					collectionScroll.style.cursor = "grabbing";
					collectionScroll.style.userSelect = "none";

					pos = {
						left: collectionScroll.scrollLeft,
						top: collectionScroll.scrollTop,
						x: e.clientX,
						y: e.clientY
					};

					document.addEventListener("mousemove", mouseMoveHandler);
					document.addEventListener("mouseup", mouseUpHandler);
				};

				const mouseMoveHandler = function (e) {
					const dx = e.clientX - pos.x;
					const dy = e.clientY - pos.y;

					collectionScroll.scrollTop = pos.top - dy;
					collectionScroll.scrollLeft = pos.left - dx;
				};

				const mouseUpHandler = function () {
					collectionScroll.style.cursor = "grab";
					collectionScroll.style.removeProperty("user-select");

					document.removeEventListener("mousemove", mouseMoveHandler);
					document.removeEventListener("mouseup", mouseUpHandler);
				};

				collectionScroll.addEventListener(
					"mousedown",
					mouseDownHandler
				);
			}
		}
	}
};

const observer = new MutationObserver(callback);

observer.observe(targetNode, observerConfig);
